import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

const featuredArticles = articles.filter((a) => a.isFeatured).slice(0, 3);
const mainArticle = featuredArticles[0];

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20editorial%20background%20with%20soft%20warm%20amber%20and%20deep%20brown%20gradient%20overlay%2C%20abstract%20geometric%20shapes%20merging%20into%20darkness%2C%20luxurious%20and%20mysterious%20atmosphere%2C%20magazine%20editorial%20style%2C%20high%20contrast%2C%20cinematic%20lighting%20with%20subtle%20warm%20highlights%2C%20no%20text%2C%20no%20people%2C%20clean%20minimal%20abstract%20composition&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="今日吃瓜 - 热门爆料背景"
          className="w-full h-full object-cover object-top"
          title="今日吃瓜热门爆料"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 pt-20 pb-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left Text */}
          <div className="w-full lg:w-[42%] text-white">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/30 bg-white/10 mb-6">
              <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
              <span className="text-xs font-medium tracking-wide">实时更新中</span>
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black font-heading leading-tight mb-4">
              热门<span className="italic text-accent-400">吃瓜</span>
              <br />
              <span className="italic text-accent-400">黑料爆料</span>追踪
            </h1>
            <p className="text-white/70 text-sm md:text-base max-w-md mb-8 leading-relaxed">
              覆盖91今日吃瓜、今日吃瓜合集、51国产吃瓜在线等核心频道，每日更新最新黑料爆料与热门吃瓜事件，一站式追踪全网八卦热点。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to={`/article/${mainArticle.slug}`}
                className="px-6 py-3 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-all text-center whitespace-nowrap cursor-pointer"
              >
                立即开吃
              </Link>
              <Link
                to="/category/collection"
                className="px-6 py-3 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-all text-center whitespace-nowrap cursor-pointer"
              >
                浏览合集
              </Link>
            </div>
          </div>

          {/* Right Featured Card */}
          <div className="w-full lg:w-[58%]">
            <Link
              to={`/article/${mainArticle.slug}`}
              className="block group cursor-pointer"
            >
              <div className="relative rounded-2xl overflow-hidden bg-background-100/10 backdrop-blur-sm border border-white/10">
                <img
                  src={mainArticle.imageUrl}
                  alt={mainArticle.title}
                  title={mainArticle.title}
                  className="w-full h-64 md:h-80 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 via-black/40 to-transparent">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2.5 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                      热门爆料
                    </span>
                    <span className="text-white/60 text-xs">{mainArticle.date}</span>
                  </div>
                  <h2 className="text-xl md:text-2xl font-bold font-heading text-white group-hover:text-accent-300 transition-colors">
                    {mainArticle.title}
                  </h2>
                  <p className="text-white/60 text-sm mt-1 line-clamp-2">{mainArticle.excerpt}</p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}